var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('p',[_vm._v("\n    User Info (Component 2):\n  ")]),_c('p',[_vm._v("\n    Name: "+_vm._s(_vm.$user.name)+"\n  ")]),_c('p',[_vm._v("\n    Role: "+_vm._s(_vm.$user.isAdmin()?'Admin':'User')+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }